import script from "./BlogPostBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogPostBlock.vue?vue&type=script&setup=true&lang=js"

import "./BlogPostBlock.vue?vue&type=style&index=0&id=e30f8be4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e30f8be4"]])

export default __exports__